import { render } from "./TransferMenu.vue?vue&type=template&id=1ebd8b9a"
import script from "./TransferMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferMenu.vue?vue&type=script&setup=true&lang=js"

import "./TransferMenu.vue?vue&type=style&index=0&id=1ebd8b9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/TransferMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ebd8b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ebd8b9a', __exports__)) {
    api.reload('1ebd8b9a', __exports__)
  }
  
  module.hot.accept("./TransferMenu.vue?vue&type=template&id=1ebd8b9a", () => {
    api.rerender('1ebd8b9a', render)
  })

}


export default __exports__